<template>
  <div>
    <div v-if="portal!='kiosk'">
      <basic-user-dashboard/>
    </div>
    <div v-if="portal=='kiosk'">
      <kiosk-user-dashboard/>
    </div>
  </div>
</template>
<script>
import BasicUserDashboard from "./BasicUserDashboard";
import KioskUserDashboard from "./KoiskUserDashboard";
export default {
  components: {
    BasicUserDashboard,
    KioskUserDashboard
  },
  data() {
    return {
      portal: this.$store.state.AppActiveUser.portalRole
    };
  }
};
</script>
<style lang="scss">
.booking-content-scroll-area {
  position: absolute;
  margin: auto;
  width: 100%;
  height: calc(100% );
  &:not(.ps) {
    overflow-y: auto;
  }
}
// .map-side {
//   // height: calc(var(--vh, 1vh) * 100);
//   // .vs-sidebar--items {
//   //   overflow: hidden;
//   //   height: 100%;
//   // }
// }
.map-cls {
  height: calc(var(--vh, 1vh) * 100 - 28.5rem);
}
.header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.mt-20 {
  margin-top: 20px;
}
.w-300 {
  width: 300px;
}
.h-150 {
  height: 150px;
}
</style>


